<form class="form" ngNoForm (submit)="$event.preventDefault(); $event.stopPropagation()">
  <input
    #autocompleteRef="cdkOverlayOrigin"
    cdkOverlayOrigin
    type="text"
    class="input"
    [placeholder]="placeholder"
    autocapitalize="off"
    autocomplete="off"
    autocorrect="off"
    enterkeyhint="search"
    spellcheck="false"
    [(ngModel)]="value"
    [disabled]="disabled"
    (input)="onInputValueChange()"
    (keydown.enter)="onInputEnterKeyDown()"
    [maxlength]="maxLength"
    (focus)="open()"
  />
  <div class="right">
    <cx-icon *ngIf="!loading; else spinner" type="SEARCH"></cx-icon>
    <ng-template #spinner>
      <sd-spinner [size]="26"></sd-spinner>
    </ng-template>
  </div>
</form>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="autocompleteRef"
  [cdkConnectedOverlayOpen]="opened()"
  (detach)="close()"
  (overlayOutsideClick)="close()"
  [cdkConnectedOverlayPositions]="[{ originY: 'bottom', overlayY: 'top', originX: 'start', overlayX: 'start' }]"
>
  <sd-dropdown-menu *ngIf="items" class="items" (click)="close()">
    <sd-dropdown-menu-item *ngFor="let item of items" class="item" (click)="onDropdownMenuItemSelect(item)">
      <ng-container *ngIf="itemTemplate; else defaultItem">
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
      </ng-container>

      <ng-template #defaultItem>
        {{ item.label }}
      </ng-template>
    </sd-dropdown-menu-item>
  </sd-dropdown-menu>
</ng-template>
